<template>
  <v-container fluid class="mt-16 px-6">
    <div>
      <v-card flat>
        <v-card-title class="d-flex"
          ><h2>Branches</h2>

          <v-spacer></v-spacer>
          <add-branch-modal />
        </v-card-title>
        <v-card-text>
          <v-data-table :items="branches" :headers="branch_headers">
            <template v-slot:item.actions="{ item }">
              <v-btn icon small color="primary" @click="openEdit(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <edit-branch-modal :show.sync="editDialog" :branch="selectedBranch" />
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import AddBranchModal from "../components/Branches/addBranchModal.vue";
import EditBranchModal from "../components/Branches/editBranchModal.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { AddBranchModal, EditBranchModal },
  computed: {
    ...mapGetters({
      branches: "branch/branches",
    }),
  },
  methods: {
    ...mapActions({
      get_branches: "branch/get_branches",
    }),
    openEdit(branch) {
      this.selectedBranch = Object.assign({}, branch);
      this.editDialog = true;
    },
  },
  data() {
    return {
      editDialog: false,
      selectedBranch: {},
      branch_headers: [
        { text: "ID", value: "id" },
        { text: "Branch Name", value: "branch_name" },
        { text: "Branch Address", value: "branch_address" },
        { text: "Branch TIN", value: "branch_tin" },
        { text: "Branch Number", value: "branch_number" },
        { text: "Delivery Information", value: "delivery_information" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  created() {
    if (this.branches.length == 0) return this.get_branches();
  },
};
</script>

<style></style>
